import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import Grid from '@material-ui/core/Grid';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import AlertDialog from '../../../../../../../components/AlertDialog/index.es6';
import ModalInc from '../../../../../../../shared-ui/ModalInc';
import ButtonInc from '../../../../../../../shared-ui/ButtonInc';
import { getPartnerGuid } from '../../../../../../../lib/access.es6';
import { reloadPage } from '../../../../../../../lib/utils.es6';
import useProductCurrency from '../../../../../../../hooks/useProductCurrency';

const RemovePremium = (props) => {
  const [reason, setReason] = useState('');
  const currencyCode = useProductCurrency(
    props.premiumToRemove && props.premiumToRemove.product_code
  );

  if (!props.premiumToRemove) {
    return null;
  }

  const handleRemove = () => {
    console.log(props.premiumToRemove)
    props.removePremium({
      payment_guid: props.premiumToRemove.payment_guid,
      policy_guid: props.policyGuid,
      partner_guid: getPartnerGuid(),
      status: props.premiumToRemove.active ? 'Succeeded' : 'Failed',
      payment_failure_reason: reason,
    });
  };

  const handleCancel = () => {
    setReason('');
    props.resetPremiumToRemove();
  };

  const handleSuccess = () => {
    props.resetRemovePremiumSuccessAlert();
    props.resetPremiumToRemove();
    reloadPage();
  };

  const handleError = () => {
    props.resetRemovePremiumErrorAlert();
  };

  const isSubmitting = props.showRemovePremiumProgressAlert;
  const showForm = !isSubmitting && !props.showRemovePremiumSuccessAlert && !props.showRemovePremiumErrorAlert;

  return (
    <>
      <AlertDialog
        custom
        show={isSubmitting}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Removing Premium...</h2>
      </AlertDialog>

      <ModalInc
        modalTitle="Remove Premium"
        subTitle="Provide a reason for removing this premium. This action cannot be undone."
        open={showForm}
        close={handleCancel}
        fullWidth
        maxWidth="sm"
      >
        <Grid container spacing={2} style={{ marginBottom: '16px' }}>
          <Grid item xs={12} sm={6} md={6}>
            <p style={{ margin: '4px 0', fontSize: '12px', color: '#A9A9A9' }}>Payment Reference</p>
            <p style={{ margin: '0', fontSize: '14px', fontWeight: 600 }}>
              {props.premiumToRemove.reference || 'N/A'}
            </p>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <p style={{ margin: '4px 0', fontSize: '12px', color: '#A9A9A9' }}>Amount</p>
            <p style={{ margin: '0', fontSize: '14px', fontWeight: 600 }}>
              {currencyCode} {props.premiumToRemove.amount_in_cents / 100}
            </p>
          </Grid>
        </Grid>

        <ValidatorForm onSubmit={handleRemove}>
          <TextValidator
            name="reason"
            label="Reason for removal"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            validators={['required']}
            errorMessages={['Please provide a reason for removal']}
            style={{ marginBottom: '16px' }}
          />

          <Grid container spacing={2} style={{ marginTop: '8px' }}>
            <Grid item xs={12} sm={6} md={6}>
              <ButtonInc
                variant="contained"
                size="large"
                onClick={handleCancel}
                disabled={isSubmitting}
                style={{ width: '100%' }}
              >
                Cancel
              </ButtonInc>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <ButtonInc
                type="submit"
                variant="contained"
                size="large"
                disabled={isSubmitting}
                style={{ width: '100%', background: '#d32f2f', color: '#ffffff' }}
              >
                {isSubmitting ? <CircularProgress size={20} color="inherit" /> : 'Confirm Remove'}
              </ButtonInc>
            </Grid>
          </Grid>
        </ValidatorForm>
      </ModalInc>

      <AlertDialog
        success
        show={props.showRemovePremiumSuccessAlert}
        size="sm"
        title={props.removePremiumPending ? 'Sent for approval' : 'Premium removed successfully'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={handleSuccess}
        confirmBtnText={'Ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'ok'}
        confirmBtnCssClass
      >
        <div>
          {props.removePremiumPending && (
            <p>The premium is removed and refunded once a second person approves it.</p>
          )}
          <ButtonInc onClick={handleSuccess} style={{ background: 'green', color: '#ffffff' }}>Ok</ButtonInc>
        </div>
      </AlertDialog>

      <AlertDialog
        show={props.showRemovePremiumErrorAlert}
        danger
        title={'Error removing premium'}
        onConfirm={handleError}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {props.removePremiumError
          ? (typeof props.removePremiumError === 'string'
            ? props.removePremiumError
            : 'Could not remove premium. Please try again.')
          : 'Could not remove premium. Please try again.'}
      </AlertDialog>
    </>
  );
};

export default RemovePremium;
